export function updateOrder(order) {
  window.dispatchEvent(new CustomEvent("updateorder", { detail: order }));
}
